import { skipToken, useQuery } from "@tanstack/react-query";
import {
  type AddressSuggestionDto,
  getAddressesSearch,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { MS_TIME } from "Utils/TimeUtils";

const ADDRESSES_SEARCH_QUERY_KEY = "ADDRESSES_SEARCH";

export const addressesSearchKeys = {
  all: [ADDRESSES_SEARCH_QUERY_KEY],
  byQuery: (query: string, limit: number) => [
    ...addressesSearchKeys.all,
    query,
    limit,
  ],
};

/** Minimum characters before we hit the GeoApi proxy. Shared with AddressAutocomplete. */
export const ADDRESS_SEARCH_MIN_LENGTH = 3;
const DEFAULT_LIMIT = 8;

type Props = {
  query: string;
  limit?: number;
};

export const useSearchAddressesQuery = ({
  query,
  limit = DEFAULT_LIMIT,
}: Props) => {
  const trimmedQuery = query.trim();
  const isEnabled = trimmedQuery.length >= ADDRESS_SEARCH_MIN_LENGTH;

  return useQuery<Array<AddressSuggestionDto>>({
    queryKey: addressesSearchKeys.byQuery(trimmedQuery, limit),
    queryFn: isEnabled
      ? processResponseWithApiProblemDetails(() =>
          getAddressesSearch(trimmedQuery, limit),
        )
      : skipToken,
    staleTime: 5 * MS_TIME.minute,
  });
};
